import { createSelector } from 'reselect'
import { listFeatureStateSelector } from './listFeatureStateSelector'

export const currentPageSelector = createSelector(listFeatureStateSelector, listFeature => listFeature.currentPage)
